import { useTranslation } from 'react-i18next'
import i18n from 'i18next';

const ChangeLocalization = () => {
  const { t } = useTranslation()

  return (
    <div className='menu-item changeLocale'>
      <a id="changeLocale" className="" onClick={(e) => i18n.changeLanguage("ru")}>
        🇷🇺 Русский
      </a>
      <a id="changeLocale" className="" onClick={(e) => i18n.changeLanguage("en")}>
        🇬🇧 English
      </a>
    </div>
  );
};

export default ChangeLocalization;
